import {  PlusCircle } from "lucide-react";
import { ReactNode } from "react";
import DialogComponent from "./DialogComponent";
import ButtonComponent from "@/components/button/ButtonComponent";

type Props = {
  title: string;
  subtitle: string;
  formEl: ReactNode
  open: boolean;
  setOpen?: (open: boolean) => void; 
  // onChange?: (open: boolean) => void; 
};

export default function AddElement({ title, subtitle, formEl, open, setOpen }: Props) {

  return (
    <DialogComponent
      open={open}
      setOpen={setOpen}
      title={title}
      subtitle={subtitle}
      trigger={
        <ButtonComponent 
          title={title}
          icon={<PlusCircle className="h-4 w-4" />}
          className="md:min-w-[150px] flex gap-1 text-xs text-white bg-purple hover:bg-purple/80"
        />
      }
      components={formEl}
    />

  );
}
